import { useMemo } from 'react';

interface NavItemProps {
  title: string;
  url: string;
  target: string;
}

interface UseNavigationProps {
  navigation?: {
    navItems: NavItemProps[];
  };
}

function useNavigation({ navigation }: UseNavigationProps) {
  const navigationData = useMemo(() => {
    return navigation?.navItems;
  }, [navigation]);

  return navigationData || [];
}

export default useNavigation;
